export default "__VITE_ASSET__Bmc4YFh8__"